module.exports = __webpack_public_path__ + "static/media/deactivate.bd245af0.svg";